import cx from "classnames";
import { Icon, EditableText, Flex } from "@theorgchartdev/storybook";
import React from "react";
import ActionListItem from "../../../../Composites/ActionListItem/ActionListItem";
import { enumCalcTypes } from "./FieldsFormulasConfiguration";
import { FIELDS_FORMULAS_TEST_PREFIX } from "./Utils";
import { FieldLabelComposite } from "@/appComponents/Blocks/Composites/FieldLabelComposite/FieldLabelComposite";
import { appstr } from "@coreapp/utils/appstr";

const FieldFormulaIconLabel = ({
  rowState,
  value,
  handleFieldAction,
  fieldMapping,
  systemGeneratedFields
}) => {
  const getIconProp = name => {
    return {
      name: name,
      size: "small",
      modifier: "default",
      layout: "default"
    };
  };

  const data = rowState?.data;
  const type = data?.type;
  const calc = data?.calc;
  const name = data?.name;
  const label = data?.label;
  const dataTestId = `field-formula-row-${name}`;

  const isStaticFormula = data?.staticFormula === true;
  const isDynamicFormula = data?.calc === enumCalcTypes.dynamic;
  let iconName = "";
  switch (type) {
    case "Text":
      iconName = "font";
      break;
    case "Number":
      iconName = "font";
      break;
    case "Image":
      iconName = "image";
      break;
    case "Date":
      iconName = "calendar";
      break;
    case "Object":
      iconName = "function";
      break;
    default:
      iconName = "file-circle-question";
      break;
  }
  if (isStaticFormula) iconName = "function";
  else if (isDynamicFormula) iconName = "lambda";
  else if (calc === enumCalcTypes.aggregated) iconName = "sigma";

  const iconColor = "dark";
  const iconProps = getIconProp(iconName);
  const baseIconClass = "ocn-file-directory-icon";
  const colorClass = `${baseIconClass}--${iconColor}`;
  const isSelected = false;
  const activeIconClass = isSelected ? "ocn-file-row-active" : colorClass;

  let actions = [
    {
      dataTestId: `${dataTestId}-editFormat`,
      iconName: "pen-to-square",
      tooltipProps: { message: appstr("Edit field format") },
      onClick: () => handleFieldAction("editFormat", data)
    }
  ];
  if (isStaticFormula || calc === enumCalcTypes.aggregated || isDynamicFormula) {
    actions = [
      {
        iconName: "pen-to-square",
        tooltipProps: { message: appstr("Edit field format") },
        onClick: () => handleFieldAction("editFormat", data)
      },
      {
        dataTestId: isDynamicFormula
          ? `${FIELDS_FORMULAS_TEST_PREFIX}-edit-dynamic-formula-${name}`
          : `${dataTestId}-editFormula`,
        iconName: "gear",
        tooltipProps: { message: appstr("Edit configuration") },
        onClick: isDynamicFormula
          ? () => handleFieldAction("editDynamicFormula", data)
          : () => handleFieldAction("editFormula", data)
      },
      {
        dataTestId: isDynamicFormula
          ? `${FIELDS_FORMULAS_TEST_PREFIX}-delete-dynamic-formula-${name}`
          : `${dataTestId}--delete`,
        iconName: "trash-can",
        iconProps: { color: "error" },
        tooltipProps: { message: appstr("Delete formula") },
        onClick: isDynamicFormula
          ? () => handleFieldAction("deleteDynamicFormula", data)
          : () => handleFieldAction("deleteFormula", data)
      }
    ];
  }

  return (
    <Flex>
      <div
        className={cx(baseIconClass, activeIconClass, "oc-shrink-0")}
        style={{ paddingRight: "4px" }}
      >
        <Icon {...iconProps} />
      </div>
      <ActionListItem
        className="oc-overflow-hidden"
        dataTestId={dataTestId}
        contentBefore={
          <FieldLabelComposite
            isSelected={isSelected}
            name={name}
            label={label}
            size={"small"}
            fieldMapping={fieldMapping}
            systemGeneratedFields={systemGeneratedFields}
          />
        }
        actions={actions}
      />
    </Flex>
  );
};

export default FieldFormulaIconLabel;
